import styles from "../SpellChecker.module.css"
import React from "react";
import {Tooltip} from "@material-ui/core";

let StyleButton = (props) => {
    let onToggle = e => {
        e.preventDefault ();
        props.onToggle (props.style)
    }

    return <span className={props.isDisabled?styles.disabledBtn: styles.btn }
                 onMouseDown={ onToggle }
    >
        <Tooltip title={ props.label } aria-label={ props.label } placement={ "top" } disableHoverListener={props.isDisabled}>
              { props.icon }
        </Tooltip>
    </span>
}

export default StyleButton